import {Injectable} from "@angular/core";
import {IObjListEntry} from "./../definitions";
import {COMPARATOR_TYPES} from "../enums/enums";


@Injectable()
export class ObjListService {
    constructor() {
    }

    addTo(document: any, prop: string) {
        let objects: IObjListEntry[] = document[prop];
        if (!objects) {
            return;
        }

        let obj: IObjListEntry = {
            id: 0,
            lvl: 0,
            cmp: COMPARATOR_TYPES.EQ
        };
        objects.push(obj);
    }
}


// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/objListService.ts